import request from '@/utils/request';

export function getOrderList(values) {
  return request('/order/queryOrderPage', {
    method: 'POST',
    data: values,
  });
}

export function getOrderSummary(values) {
  return request('/order/queryOrderPageSummary', {
    method: 'POST',
    data: values,
  });
}
